import React, { useMemo } from 'react';
import { Button, Typography } from '@material-ui/core';
import pluralize from 'pluralize';
import styled from 'styled-components';
import { buildDisplayName } from './shared';
const CollaboratorsBylineContainer = styled.div `
    display: flex;
    align-items: center;
    margin: -0.5rem 0;
    color: ${(props) => props.theme.colors.textSecondary};

    button {
        margin-left: -0.75rem;
    }

    .MuiButton-root:hover {
        background-color: transparent;
    }
`;
const ButtonText = styled.span `
    text-decoration: underline;
    color: ${(props) => props.theme.colors.textSecondary};
`;
export const CollaboratorsByline = ({ collaborators, handleCollaboratorsModalOpen }) => {
    const andOthersText = useMemo(() => {
        if (collaborators.length > 1) {
            return `and ${pluralize('other', collaborators.length - 1, true)}`;
        }
        return '';
    }, [collaborators]);
    const collaboratorsText = useMemo(() => {
        const firstCollaboratorDisplayName = buildDisplayName(collaborators[0]);
        if (firstCollaboratorDisplayName) {
            return `${firstCollaboratorDisplayName} ${andOthersText}`;
        }
    }, [collaborators, andOthersText]);
    return collaborators.length > 0 ? (React.createElement(CollaboratorsBylineContainer, null,
        collaboratorsText ? React.createElement(Typography, { variant: "body2" }, "by ") : null,
        React.createElement(Button, { onClick: handleCollaboratorsModalOpen, "aria-label": "open collaborators modal" },
            React.createElement(ButtonText, null, collaboratorsText !== null && collaboratorsText !== void 0 ? collaboratorsText : 'See all collaborators')))) : null;
};
//# sourceMappingURL=CollaboratorsByline.js.map